<template>
  <div>
    <a-layout class="sider-box" style="height: 100vh">
      <div
        v-if="!collapsed"
        class="collapsed"
        @click="handleCollapsed"
        style="left: 240px"
      >
        <DoubleLeftOutlined />
      </div>
      <div v-else class="collapsed" @click="handleCollapsed" style="left: 80px">
        <DoubleRightOutlined />
      </div>
      <a-layout-sider
        v-model:collapsed="collapsed"
        :trigger="null"
        collapsible
        width="240"
        theme="light"
      >
        <a-layout>
          <a-layout-header>
            <div class="side-header" v-if="!collapsed">
              <img
                v-if="VUE_APP_VERSION == 'hprt'"
                class="here-logo-img"
                src="../../assets/here/here-logo.png"
                alt=""
              />
              <img v-else class="logo-img" src="../../assets/logo.png" alt="" />
            </div>
            <div class="min-side-header" v-else>
              <img
                v-if="VUE_APP_VERSION == 'hprt'"
                class="here-mini-logo-img"
                src="../../assets/here/here-logo.png"
                alt=""
              />
              <img
                v-else
                class="mini-logo-img"
                src="../../assets/logo.png"
                alt=""
              />
            </div>
          </a-layout-header>
          <a-layout-content class="layout-content">
            <SideMenu ref="SideMenuRef" />
          </a-layout-content>
        </a-layout>
      </a-layout-sider>
      <a-layout-content style="background: #f3f6fa; height: 100vh">
        <!-- <router-view></router-view> -->
        <router-view v-slot="{ Component }">
          <!-- <keep-alive>
            <component :is="Component" v-if="keepAlive" />
          </keep-alive> -->
          <component :is="Component" />
        </router-view>
      </a-layout-content>
    </a-layout>
  </div>
</template>
<script>
import SideMenu from "@/components/layouts/SideMenu.vue";
import { message } from "ant-design-vue";
import { getExplorer } from "../../utils/device";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  DoubleRightOutlined,
  DoubleLeftOutlined,
} from "@ant-design/icons-vue";
import {
  defineComponent,
  onMounted,
  ref,
  getCurrentInstance,
  watch,
  reactive,
  toRefs,
  onBeforeMount,
} from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
export default defineComponent({
  components: {
    SideMenu,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    DoubleRightOutlined,
    DoubleLeftOutlined,
  },
  setup() {
    const { proxy } = getCurrentInstance();
    let globalProperties =
      getCurrentInstance().appContext.config.globalProperties;
    const axios = globalProperties.$axioshanma;
    const router = useRouter();
    const store = useStore();
    const offsetWidth = ref(1920);

    const state = reactive({
      SideMenuRef: null,
      collapsed: false,
      VUE_APP_VERSION: process.env.VUE_APP_VERSION,
    });
    onMounted(() => {
      let explorer = getExplorer();
      if (explorer == "Firefox") {
        let firstOpen = store.getters.getFirstOpen;
        if (firstOpen) {
          message.warning(proxy.$t(`tips.tip79`));
          store.commit("setFirstOpen", false);
        }
      }
      offsetWidth.value = document.body.offsetWidth;
      window.onresize = () => {
        return (() => {
          offsetWidth.value = document.body.offsetWidth;
        })();
      };
      axios("/api/tem.app_shared/configuration")
        .then((res) => {
          localStorage.setItem("configuration", JSON.stringify(res));
        })
        .catch((err) => {
          console.log(err);
        });
    });
    watch(
      () => globalProperties.$nickname,
      () => {
        nickname.value = globalProperties.$nickname;
        console.log(nickname.value);
      }
    );

    const handleCollapsed = () => {
      state.collapsed = !state.collapsed;
      state.SideMenuRef.getCollapsed(state.collapsed);
    };
    return {
      ...toRefs(state),
      offsetWidth,
      handleCollapsed,
    };
  },
});
</script>
<style>
.collapsed {
  width: 20px;
  height: 50px;
  background: #fff;
  color: #535d6c;
  position: absolute;
  left: 240px;
  top: calc(50% - 25px);
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  z-index: 99;
  transition: color 1s;
  cursor: pointer;
}
.sider-box {
  font-size: 16px;
  color: #535d6c;
  line-height: 24px;
}
.trigger {
  font-size: 30px;
  height: 96px;
  padding-left: 10px;
  cursor: pointer;
  transition: color 0.5s;
}

.trigger:hover {
  color: #003591;
}
.layout-content .anticon {
  font-size: 18px;
}
.sider-box .ant-layout-header {
  padding: 0;
  height: 96px;
  background: #fff;
}
.side-header {
  margin: 24px 20px 16px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.min-side-header {
  height: 100%;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mini-logo-img {
  width: 90%;
  height: auto;
  object-fit: contain;
}

.here-mini-logo-img {
  padding: 25px 10px;
}

.logo-img {
  width: 100%;
  height: 50px;
  object-fit: contain;
}
.here-logo-img {
  width: 110px;
  height: 61px;
}
.side-header .anticon {
  color: #003591;
}
@media only screen and (max-width: 1300px) {
  .sider-box {
    font-size: 10px;
    line-height: 16px;
  }
}
</style>
